export default class AuthError extends Error {
	error = 'Authentication failure!'
	errorDescription: string

	constructor(description: string) {
		super()
		this.errorDescription = description
	}
}
